import React from "react";

export const VimeoCoverVideo = () => (
  <div>
    <div className="video_container">
      <iframe
        title="Moonway cover video"
        src="https://player.vimeo.com/video/290293578?autoplay=1&loop=1&title=0&portrait=0&muted=1"
        frameBorder="0"
      />
    </div>
    <script src="https://player.vimeo.com/api/player.js" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Homepage/VimeoCoverVideo.js